export const form = {
  formCopyLink: 'Kopiuj link',
  formLinkCopied: 'Link skopiowany!'
}
